module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="icarus">\n    ';
 var formClass = "icarus-form" ;
__p += '\n    ';
 formClass += form.isSubmitting ? " submitting" : "" ;
__p += '\n    <form class="' +
((__t = ( formClass )) == null ? '' : __t) +
'">\n        <div class="icarus-layout">\n            <div class="icarus-layout-dynamic">\n            ';
 for (var i = 0 ; i < form.dynamicFields.length ; i++) { ;
__p += '\n            ' +
((__t = ( form.dynamicFields[i] )) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n            </div>\n\n            <div class="icarus-layout-static" style="min-height:' +
((__t = ( form.dynamicBoundingBox.bottomRight[1] )) == null ? '' : __t) +
'px;">\n            ';
 for (var i = 0 ; i < form.staticFields.length ; i++) { ;
__p += '\n            ' +
((__t = ( form.staticFields[i] )) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n            </div>\n        </div>\n\n        ';
 if (form.errors) { ;
__p += '\n        <ul class="icarus-errors">\n            ';
 for (var i = 0 ; i < form.errors.length ; i++) { ;
__p += '\n            <li>' +
((__t = ( form.errors[i] )) == null ? '' : __t) +
'</li>\n            ';
 } ;
__p += '\n        </ul>\n        ';
 } ;
__p += '\n\n        <button type="submit" class="submit-btn"';
 if (form.isSubmitting) { ;
__p += ' disabled';
 } ;
__p += '>' +
((__t = ( form.submitButton )) == null ? '' : __t) +
'</button>\n    </form>\n\n    ';
 if (form.message) { ;
__p += '\n    <span class="icarus-message">' +
((__t = ( form.message )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/form.ejs
// module id = 203
// module chunks = 2 3